"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestBufferSubmissionWindow = exports.fixSeriesDeletionDate = exports.findSeriesDeletionDate = void 0;
const moment_1 = __importDefault(require("moment"));
const time_1 = require("./time");
const findSeriesDeletionDate = (series) => {
    const startDatePlus15M = (0, moment_1.default)(series.startDate || (0, time_1.buildNow)()())
        .parseZone()
        .add(15, 'months');
    const deletionDate = series.deletionDate ? (0, moment_1.default)(series.deletionDate).parseZone() : startDatePlus15M;
    const [lastBuffer, ..._rest] = series.submissionWindows
        .map((sw) => (0, moment_1.default)(sw.buffer).parseZone())
        .sort((buffer1, buffer2) => moment_1.default.utc(buffer2).diff(moment_1.default.utc(buffer1)));
    if (lastBuffer &&
        (0, moment_1.default)(series.startDate || (0, time_1.buildNow)()()).diff(lastBuffer) < 0 &&
        deletionDate.diff(lastBuffer) < 0) {
        return lastBuffer.add(6, 'months').toISOString();
    }
    if (deletionDate < startDatePlus15M) {
        return startDatePlus15M.toISOString();
    }
    return deletionDate.toISOString();
};
exports.findSeriesDeletionDate = findSeriesDeletionDate;
const fixSeriesDeletionDate = (series) => {
    const deletionDateISO = (0, exports.findSeriesDeletionDate)(series);
    if (deletionDateISO !== series.deletionDate) {
        return { series: Object.assign(Object.assign({}, series), { deletionDate: deletionDateISO }), changed: true };
    }
    return { series, changed: false };
};
exports.fixSeriesDeletionDate = fixSeriesDeletionDate;
/**
 * Returns latest submissionWindow buffer date for given series
 * @param series series to get submissionWindows from
 * @returns string or undefined
 */
const getLatestBufferSubmissionWindow = (series) => {
    var _a;
    if (!((_a = series === null || series === void 0 ? void 0 : series.submissionWindows) === null || _a === void 0 ? void 0 : _a.length))
        return;
    return moment_1.default.max(series.submissionWindows.map((submissionWindow) => (0, moment_1.default)(submissionWindow.buffer))).toISOString();
};
exports.getLatestBufferSubmissionWindow = getLatestBufferSubmissionWindow;
